// extracted by mini-css-extract-plugin
export var logo = "_ho-2";
export var logoWrapper = "_ho-1";
export var strip = "_ho-0";